



















































import Vue from 'vue';
import store from '@/store';
import { OrgPeerGroup } from '@/models/orgStructure';
import { BaseOrganization, MemberRole, WebRequestStatus } from '@/models';

import PeerGroupSettingsEditor, {
  UpdatedSettings
} from '@/components/PeerGroupSettingsEditor.vue';
import BottomActionBar from '@/components/utils/BottomActionBar.vue';

export default Vue.extend({
  components: {
    PeerGroupSettingsEditor,
    BottomActionBar
  },

  props: {
    peerGroupId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      model: null as null | UpdatedSettings,
      dirty: false
    };
  },

  computed: {
    organization(): BaseOrganization {
      return store.state.org.basic;
    },

    peerGroup(): OrgPeerGroup {
      return store.getters.org.peerGroup(this.peerGroupId);
    },

    adminAccess(): boolean {
      return store.state.org.adminAccess;
    },

    isCreator(): boolean {
      const userId = store.state.org.userInfo.userId;

      return this.peerGroup.createdById == userId;
    },

    canEdit(): boolean {
      if (this.adminAccess) {
        return true;
      }

      const userId = store.state.org.userInfo.userId;

      return this.peerGroup.members
        .filter(m => m.role === MemberRole.TEACHER)
        .some(m => m.userId === userId);
    },

    status(): WebRequestStatus {
      return store.state.org.activeRequests.group.getStatus(
        this.peerGroup.peerGroupId
      );
    },

    canSave(): boolean {
      return this.canEdit && this.dirty;
    },

    widthSpecificClasses(): string {
      return this.$vuetify.breakpoint.mdAndUp
        ? 'bottom-bar-no-top-nav'
        : 'bottom-bar-with-top-nav';
    }
  },

  methods: {
    handleChange({ model, dirty }: { model: UpdatedSettings; dirty: boolean }) {
      this.model = model;
      this.dirty = dirty;
    },

    exit() {
      this.$router.push({
        name: 'OrganizationPeerGroup',
        params: {
          organizationId: `${this.organization.organizationId}`,
          peerGroupId: `${this.peerGroupId}`
        }
      });
    },

    async save() {
      if (!this.model) {
        // Should never get here, as this is gatekept by the
        // `dirty` flag.
        return;
      }

      await store.dispatch.org.updatePeerGroup(this.model);

      this.$emit('saved');

      // TODO: Handle pop here
      this.exit();
    },

    async deactivate() {
      await store.dispatch.org.deactivatePeerGroup(this.peerGroup.peerGroupId);

      this.$emit('deactivated');

      this.exit();
    },

    forceClassroomSync() {
      store.dispatch.org.syncClassroomCourse({
        peerGroupId: this.peerGroup.peerGroupId,
        isCreator: this.isCreator
      });
    }
  }
});
